<template>
  <el-container>
    <el-main :class="($route.name || 'page').kebabCase()">
      <router-view v-if="!checkingRedirect" />
      <div
        v-if="showSnackBar"
        class="snackbar"
      >
        <h3>
          {{ $t("reset-cache.title") }}
          <el-button
            type="text"
            @click="reloadPage"
          >
            {{ $t("reset-cache.button") }}
          </el-button>
        </h3>
      </div>
    </el-main>
  </el-container>
</template>

<script>
import { Auth } from "@aws-amplify/auth";
import authHelpers from './plugins/auth-helpers';

export default {
  name: "Home",
  data: () => ({
    showSnackBar: false,
    checkingRedirect: true
  }),
  created() {
    const origin = window.location.origin;
    const pathname = window.location.pathname;

    if (pathname.length > 1) {
      window.location.href = `${origin}#${pathname}`;
      return;
    }
    if (this.$router.currentRoute.name !== "Pay") {
      Auth.currentAuthenticatedUser({
        bypassCache: true,
      }).then(async (user) => {
        if(await authHelpers.isCurrentUserAdmin()) return

        this.$adminApi
          .get("/api/v1/entities/employees/" + user.attributes.sub)
          .then(async (response) => {
            response.data.forEach(org => {
              if (
              org.newDesignAdmin &&
              process.env.VUE_APP_NEW_DESIGN_ADMIN_URL
            ) {
              window.location.href = process.env.VUE_APP_NEW_DESIGN_ADMIN_URL;
              return;
            }
            });
          });
      });
    }

    this.checkingRedirect = false
    const hostParts = window.location.host.split(".");
    const domain =
      hostParts.length > 1 ? hostParts[hostParts.length - 1] : "en";
    const locales = Object.keys(this.$i18n.messages);
    if (this.$cookie.get("locale")) {
      this.$i18n.locale = this.$cookie.get("locale");
    } else {
      const browserLocale = navigator.language.split("-")[0];
      this.$i18n.locale = locales.includes(browserLocale)
        ? browserLocale
        : locales.includes(domain)
        ? domain
        : "en";
    }

    document.addEventListener(
      "serviceWorkerUpdateEvent",
      () => {
        this.showSnackBar = true;
      },
      { once: true }
    );
  },
  methods: {
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.selectemployee {
  background-color: #f6f7f9;
}

.el-container {
  width: 100%;
  display: block;
}

.el-main {
  min-height: 100vh;
  padding: 0;
}

.snackbar {
  position: fixed;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  padding: 15px;
  border: 1px solid #e3e5e5;
  border-radius: 8px;
  z-index: 999;
}
</style>
